import api from "./api";

export async function fetchStatuses(types) {
  const allowedTypes = ["all", "orders", "payment"];

  // Check if types is not an array or empty, then replace with ["all"]
  if (!Array.isArray(types) || types.length === 0) {
    types = ["all"];
  }

  const filteredTypes = types.filter((type) => allowedTypes.includes(type));

  const query = filteredTypes
    .map((type) => `types[]=${encodeURIComponent(type)}`)
    .join("&");

  try {
    const isStaff = window.location.pathname.includes("/restaurant-staff/");
    const apiPrefix = isStaff ? "restaurant-staff" : "restaurant";
    const res = await api.get(`${apiPrefix}/statuses${query ? `?${query}` : ""}`);

    if (res.success) {
      return res.data || {};
    } else {
      console.warn("Unexpected response status:", res.status);
      return {};
    }
  } catch (error) {
    console.error("Error fetching statuses:", error);
    return {};
  }
}

// src/utils/fetchSubcategories.js
export async function fetchSubcategories() {
  try {
    const isStaff = window.location.pathname.includes("/restaurant-staff/");
    const apiPrefix = isStaff ? "restaurant-staff" : "restaurant";
    const res = await api.get(`${apiPrefix}/subcategory/all`);
    if (res.success) {
      return res.data || [];
    } else {
      console.warn("Unexpected response:", res.status);
      return [];
    }
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return [];
  }
}


export async function fetchLanguages() {
  const isStaff = window.location.pathname.includes("/restaurant-staff/");
  const apiPrefix = isStaff ? "restaurant-staff" : "restaurant";
  const res = await api.get(`${apiPrefix}/lang/all`);
  if (res.success) {
    return res.data || [];
  } else {
    return [];
  }
}
